<template>
    <div class="container">
        <div class="return" title="返回" @click="handleReturn">
            <i class="iconfont iconfontfanhui"></i>
        </div>
        <div class="content">
            <el-skeleton v-if="showSkeleton" :rows="32" animated/>
            <div v-else class="markdown-body" ref="container">

            </div>
        </div>
    </div>
</template>

<script>
import 'fast-text-encoding';


export default {

    name: "infoDetail",
    data() {
        return {
            showSkeleton: true,
        };
    },
    mounted() {

    },
    methods: {
        //获取文件
        init(fileName) {
            //进入页面后滚动到顶部
            document.querySelector('.header-bg').scrollIntoView()
            const encoder = new TextDecoder();
            fetch(`${process.env.VUE_APP_URL}/html/${fileName}/index.html`,).then(res => {
                let stream = res.body.getReader();
                stream.read().then(res => {

                    setTimeout(() => {
                        this.showSkeleton = false;
                        this.$nextTick(() => {
                            this.$refs.container.innerHTML = encoder.decode(res.value);
                        })
                        this.$nextTick(() => {
                            let p_el = document.querySelector('.markdown-body');
                            let p = p_el.querySelectorAll('p > img');
                            if (p.length > 0) {
                                p.forEach(item => {
                                    item.parentNode.style.display = 'flex';
                                    item.parentNode.style.justifyContent = 'center';
                                });
                            }
                        });
                    }, 500)
                });
            });
        },
        handleReturn() {
            this.$emit('returnPage')
            this.$refs.container.innerHTML = ''
            this.showSkeleton = true;
        }
    }
}
</script>


<style scoped lang="scss">
.container {
    height: 100%;
    width: 100%;
    position: relative;
    padding: 16px;
    box-sizing: border-box;

    .return {
        cursor: pointer;
        position: fixed;
        padding: 10px;
        box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
        background: #ffffff;
        border-radius: 50%;
        color: #409eff;
        right: 64px;
        z-index: 3;
        margin-top: 32px;

        @media screen and (max-width: 768px) {
            padding: 8px;
            right: 16px;
        }

        &:hover {
            background-color: #f2f6fc;
        }

        .iconfont {
            font-size: 20px;
        }
    }

    .content {
        max-width: 1200px;
        margin: 0 auto;
        padding: 32px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        box-sizing: border-box;

    }
}
</style>
